<template>
  <div :id="id" ref="app" :class="[baseCss, setDark]">
    <reactive-style>
    body,
    .bc-app
    {
      color: {{ color }};
      background-color: {{ bgColor }};
    }
    .bcq-ui-theme-dark
    {
      color: {{ darkTextColor }};
      background-color: {{ darkBgColor }};
    }
    </reactive-style>
    <slot />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'BcqApp',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('app', ['transition-all', 'duration-300'])
    }
  },
  created () {
    this.onCreated()
  },
  props: {
    id: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean
    },
    darkBgColor: {
      type: String,
      default: '#181818'
    },
    darkTextColor: {
      type: String,
      default: '#fff'
    },
    bgColor: {
      type: String,
      default: '#fff'
    },
    color: {
      type: String,
      default: '#000'
    }
  },
  computed: {
    setDark () {
      const $dark = this.$dark
      const darkCss = ['bcq-ui-theme-dark']
      const body = document.querySelector('body')
      $dark ? body.classList.add(...darkCss) : body.classList.remove(...darkCss)
      return $dark ? darkCss : null
    }
  },
  methods: {
    onCreated () {
      this.$dark = this.dark
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/bcq-app/bcq-app.vue